// extracted by mini-css-extract-plugin
export default {"container":"ExternalWarning_container__r9haA"};